// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"740":"CameraDetails","987":"CreateOrg"}[chunkId] || chunkId) + "." + {"724":"1ffeb6a7","740":"e8f1b739","987":"5aabc911"}[chunkId] + ".chunk.css";
};